import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../../components/TemplateDashboard";
import AccesosTuteaContent from './components/AccesosTuteaContent';

const AccesosTuteaListado = () => {

    return (
        <>

            <TemplateDashboard>
                <AccesosTuteaContent />
            </TemplateDashboard>

        </>
    )
};

export default AccesosTuteaListado;